import dayjs from "dayjs";
export const DEFAULT_LANGUAGE = "es";
export * from "./language";
export * from "./structured-data";
export * from "./recaptcha";
export * from "./types/filters";
export * from "./types/travel";
export * from "./format/currency";
// Utility function to parse guests parameter and return room count
export const computeRoomsCountFromGuestsParam = (guestsParam) => {
    if (!guestsParam)
        return 1;
    try {
        const guests = JSON.parse(decodeURIComponent(guestsParam));
        if (guests.guests?.rooms) {
            return guests.guests.rooms;
        }
        if (Array.isArray(guests.rooms)) {
            return guests.rooms.length;
        }
        return guests.rooms || 1;
    }
    catch {
        return 1;
    }
};
// Build stable key for stay search params (used for caching)
export const buildStayStableKey = (searchParams) => {
    const relevantParams = [
        "destId",
        "checkIn",
        "checkOut",
        "guests",
        "amenities",
        "onlyExclusiveDeal",
        "onlyWithPromotions",
    ];
    const sortedParams = relevantParams
        .filter((key) => searchParams.has(key))
        .sort()
        .map((key) => `${key}=${searchParams.get(key)}`)
        .join("&");
    return sortedParams;
};
// Parse guests parameter from URL
export const parseGuestsParam = (guestsParam) => {
    if (!guestsParam)
        return null;
    try {
        const parsed = JSON.parse(guestsParam);
        return {
            adults: parsed.adults ?? 2,
            children: parsed.children ?? 0,
            rooms: parsed.rooms ?? 1,
        };
    }
    catch {
        return null;
    }
};
export const DateUtils = {
    isValidDate: (date) => {
        const timestamp = Date.parse(date);
        return !isNaN(timestamp);
    },
    formatDate: (date) => {
        const d = new Date(date);
        return d.toLocaleDateString();
    },
    getDynamicDateOptions: (days, language) => {
        const options = [];
        for (let i = 0; i < days; i++) {
            const date = dayjs().startOf("day").toDate();
            date.setDate(date.getDate() + i);
            const dateValue = date.toISOString().split("T")[0];
            if (i === 0) {
                options.push({
                    label: "today",
                    value: dateValue,
                });
            }
            else if (i === 1) {
                options.push({
                    label: "tomorrow",
                    value: dateValue,
                });
            }
            else {
                options.push({
                    label: date.toLocaleDateString(language, {
                        weekday: "short",
                        month: "short",
                        day: "numeric",
                    }),
                    value: dateValue,
                });
            }
        }
        return options;
    },
    formatSearchBarDateOptions: (options, _locale, t) => {
        return options.map((option) => {
            let label = option.label;
            if (label === "today") {
                return { ...option, label: t("today") };
            }
            if (label === "tomorrow") {
                return { ...option, label: t("tomorrow") };
            }
            return {
                ...option,
                label: label.charAt(0).toUpperCase() + label.slice(1),
            };
        });
    },
};
